module.exports = __webpack_public_path__ + "static/media/Nekedra J.460bdaf0.png";